import FileDragAndDrop from 'file-manager-components/upload/FileDragAndDrop';
export default FileDragAndDrop;